import React from 'react';
import styles from './RiskDashboardPage.module.scss';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { HeadTitle } from '../../components/HeadTitle';
import { RiskDataGrid } from '../../components/RiskDataGrid';
import { L1RiskDataGrid } from '../../components/RiskDataGrid/L1RiskDataGrid';
import { SystemNotifications } from '../../components/SystemNotifications';
import { L1TradeRiskFilter } from '../L1TradeRiskFilter';
import { RiskDashboardFilter } from '../RiskDashboardFilter';
import { withNotificationsContext } from '../../context/Notifications.context';
import { TabNav } from '../../components/TabNav';
import { Button } from '../../components/Button';
import { getNotificationStatus, updateNotificationStatus, acknowledgeOrfAlerts, acknowledgeEcnAlerts, acknowledgeIdqsAlerts, acknowledgeLockCrossAlerts, 
  acknowledgeL1Alerts, acknowledgeTrfAlerts } from '../../api/riskNotification';
import { PAGE_TAB_ITEMS, ECN_RISK_SUMMARY, IDQS_RISK_SUMMARY, UNMATCHED_TRADES, UNMATCHED_OTHER_TRADES, LOCK_CROSS_QUOTES, L1_TRADES, TRF_TRADES, IDQS_NMS_TRADE_SYMBOL_SUMMARY, IDQS_NMS_TRADE_MMID_SUMMARY, IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
import { isMobile } from '../../util/functions';
import LiveDataGrid from '../../components/LiveDataGrid';
const { RISK_DASHBOARD_CONFIG, DASHBOARD_CONFIG, RISK_NOTIFICATION_WEB_SOCKET_API } = getConfig();
const ECN_RISK_CONFIG = RISK_DASHBOARD_CONFIG.get(ECN_RISK_SUMMARY);
const IDQS_RISK_CONFIG = RISK_DASHBOARD_CONFIG.get(IDQS_RISK_SUMMARY);
const UNMATCHED_TRADES_CONFIG = RISK_DASHBOARD_CONFIG.get(UNMATCHED_TRADES);
const UNMATCHED_OTHER_TRADES_CONFIG = RISK_DASHBOARD_CONFIG.get(UNMATCHED_OTHER_TRADES);
const LOCK_CROSS_QUOTES_CONFIG = RISK_DASHBOARD_CONFIG.get(LOCK_CROSS_QUOTES);
const L1_TRADES_CONFIG = RISK_DASHBOARD_CONFIG.get(L1_TRADES);
const TRF_TRADES_CONFIG = RISK_DASHBOARD_CONFIG.get(TRF_TRADES);
const IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NMS_TRADE_SYMBOL_SUMMARY);
const IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NMS_TRADE_MMID_SUMMARY);
const IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG = DASHBOARD_CONFIG.get(IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY);

const SOCKET_ERROR_MAX_COUNT = 5;
const NOTIFICATION_TIMEOUT = 5000;

class RiskDashboardPage extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      title: 'Risk Monitoring',
      notificationStatusLoaded: false,
      notificationStatus: null,
      failedAttempt: SOCKET_ERROR_MAX_COUNT,
      queryParam: {},
      l1QueryParam: {}
    };
    this.setNotificationStatus = this.setNotificationStatus.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
    this.setQueryParameters = this.setQueryParameters.bind(this);
    this.setL1QueryParameters = this.setL1QueryParameters.bind(this);
    this.connectToNotificationWs = this.connectToNotificationWs.bind(this);
    this.disconnectToNotificationWs = this.disconnectToNotificationWs.bind(this);
    this.reconnectToNotificationWs = this.reconnectToNotificationWs.bind(this);
    this.handleNotificationWsData = this.handleNotificationWsData.bind(this);
    this.loadNotificationSta = this.loadNotificationSta.bind(this);
    this.updateNotificationSta = this.updateNotificationSta.bind(this);
    this.orfRiskUserAck = this.orfRiskUserAck.bind(this);
    this.ecnRiskUserAck = this.ecnRiskUserAck.bind(this);
    this.idqsRiskUserAck = this.idqsRiskUserAck.bind(this);
    this.lcAlertUserAck = this.lcAlertUserAck.bind(this);
    this.l1AlertUserAck = this.l1AlertUserAck.bind(this);
    this.trfAlertUserAck = this.trfAlertUserAck.bind(this);
  }

  componentDidMount () {
    // load current notification status
    this.loadNotificationSta();
  }

  loadNotificationSta () {
    getNotificationStatus().then(data => {
      this.setState({ notificationStatus: data, notificationStatusLoaded: true });
      // connect to web socket for real time notification
      this.connectToNotificationWs();
    })
      .catch((err) => {
        // error
        console.log(err);
      });
  }

  handleNotificationWsData (data) {
    if (data.type === 'SERVICE') {
      if (data.value === 'PAUSE') {
        // stop notification
      //  this.disconnectToNotificationWs();
        this.setState({ notificationStatus: false });
      } else if (data.value === 'RESUME') {
        // start notification
        // this.connectToNotificationWs();
        this.setState({ notificationStatus: true });
      }
    } else if (data.type === 'PAYLOAD') {
      if (this.state.notificationStatus) {
        // should be always true
        this.sendNotification('Risk Exceptions Pending!');
      }
    }
  }

  updateNotificationSta (status) {
    updateNotificationStatus(status).then(data => {
      // we will update button render change from msg received from WS
    })
      .catch((err) => {
        // error
        console.log(err);
      });
  }

  orfRiskUserAck (alerts = []) {
    let orfAlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.tradeId) {
        orfAlertsPayload.push({
          id: alert.tradeId,
          userAcked: true
        });
      }
    });

    acknowledgeOrfAlerts(orfAlertsPayload).then(data => {
      this.sendNotification('Orf Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('Orf Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  ecnRiskUserAck (alerts = []) {
    let ecnAlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.internalId) {
        ecnAlertsPayload.push({
          id: alert.internalId,
          userAcked: true
        });
      }
    });

    acknowledgeEcnAlerts(ecnAlertsPayload).then(data => {
      this.sendNotification('Ecn Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('Ecn Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  idqsRiskUserAck (alerts = []) {
    let idqsAlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.internalId) {
        idqsAlertsPayload.push({
          id: alert.internalId,
          userAcked: true
        });
      }
    });

    acknowledgeIdqsAlerts(idqsAlertsPayload).then(data => {
      this.sendNotification('Idqs Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('Idqs Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  lcAlertUserAck (alerts = []) {
    let idqsAlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.alertId) {
        idqsAlertsPayload.push({
          id: alert.alertId,
          userAcked: true
        });
      }
    });

    acknowledgeLockCrossAlerts(idqsAlertsPayload).then(data => {
      this.sendNotification('Lock Cross Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('Lock Cross Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  l1AlertUserAck (alerts = []) {
    let l1AlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.tradeId) {
        l1AlertsPayload.push({
          id: alert.tradeId,
          userAcked: true
        });
      }
    });

    acknowledgeL1Alerts(l1AlertsPayload).then(data => {
      this.sendNotification('L1 Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('L1 Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  trfAlertUserAck (alerts = []) {
    let trfAlertsPayload = [];
    alerts.forEach(function (alert) {
      if (alert.alertId) {
        trfAlertsPayload.push({
          id: alert.alertId,
          userAcked: true
        });
      }
    });

    acknowledgeTrfAlerts(trfAlertsPayload).then(data => {
      this.sendNotification('TRF Trade Risk User Acknowledgement(s) will be reflected in next refresh.');
    })
      .catch((err) => {
        this.sendNotification('TRF Trade Risk User Acknowledgement(s) Failed.', 'error');
        console.log(err);
      });
  }

  setQueryParameters (queryParamObj) {
    this.setState({ queryParam: queryParamObj });
  }

  setL1QueryParameters (queryParamObj) {
    this.setState({ l1QueryParam: queryParamObj });
  }

  setNotificationStatus (status) {
    this.setState({
      notificationStatus: status
    });
  }

  disconnectToNotificationWs () {
    this.state.wsObj && this.state.wsObj.close();
  }

  componentWillUnmount () {
    this.disconnectToNotificationWs();
  }

  sendNotification (message, notificationType) {
    const [notificationState, dispatchNotification] = this.props.notificationContext;
    const id = new Date().getTime();
    dispatchNotification({
      type: 'ADD_NOTIFICATION',
      payload: {
        id: id,
        description: message,
        type: notificationType
      }
    });
    setTimeout(() => {
      dispatchNotification({
        type: 'REMOVE_NOTIFICATION',
        id: id
      });
    }, NOTIFICATION_TIMEOUT);
  }

  reconnectToNotificationWs () {
    this.connectToNotificationWs();
  }

  connectToNotificationWs () {
    const this_ = this;
    const socketApi = RISK_NOTIFICATION_WEB_SOCKET_API;

    if (socketApi && this.state.failedAttempt > 0) {
      const socket = new WebSocket(socketApi);
      socket.addEventListener('open', function (event) {
        // console.log('connected', socketApi);
        // socket.send('Hello Server!');
      });
      socket.addEventListener('message', function (event) {
        // console.log('message from server: ' + event.data);
        let data = JSON.parse(event.data);
        this_.setState({
          failedAttempt: SOCKET_ERROR_MAX_COUNT
        });
        this_.handleNotificationWsData(data);
      });
      socket.addEventListener('error', function (event) {
        console.log('error in', socketApi);
        console.log('error', event);
        this_.setState({
          failedAttempt: this_.state.failedAttempt - 1
        });
      });
      socket.addEventListener('close', function (event) {
        // console.log('closed', event);
        if (event && event.code !== 1005) {
          this_.reconnectToNotificationWs();
        }
      });
      this.setState({
        wsObj: socket
      });
    }
  };

  render () {
    const notificationStatus = this.state.notificationStatus;
    const [notificationState, dispatchNotification] = this.props.notificationContext;
    const notifications = notificationState.notifications;
    const hasNotifications = notifications && notifications.length > 0;

    return (
      <div key={'riskDashboardPage'} >
        <HeadTitle title={this.state.title} />
        <div className={styles.tabControlsContainer}>
          <TabNav tabItems={PAGE_TAB_ITEMS} />
          {this.state.notificationStatusLoaded && <div className={styles.realTimeButton}>
            {notificationStatus && <Button title='Pause Page Notification' onClick={() => this.updateNotificationSta(false)} size='extraSmall' />}
            {!notificationStatus && <Button title='Resume Page Notification' onClick={() => this.updateNotificationSta(true)} size='extraSmall' />}
          </div>}
        </div>
        {isMobile() && <div className={styles.nmsContainer}>
          <div id='nmsContainer'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >NMS</Outline>
          </div>
          <div className={styles.nmsGrid}>
            <LiveDataGrid
              identifier={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
              header={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.header}
              ws={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
              api={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.api}
              downloadApi={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
              lastUpdatedField={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
              totalField={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
              columns={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
              summaryGroupTitleColumn={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={IDQS_NMS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
              pauseWs={false}
              maxRows={10} 
              />
          </div>
          <div className={styles.nmsGrid}>
            <LiveDataGrid
              identifier={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.identifier}
              header={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.header}
              ws={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.ws}
              api={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.api}
              downloadApi={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
              lastUpdatedField={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
              totalField={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.totalField}
              columns={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.columns}
              summaryGroupTitleColumn={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={IDQS_NMS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
              pauseWs={false}
              maxRows={10} />
          </div>
          <div className={styles.nmsGrid}>
            <LiveDataGrid
              identifier={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.identifier}
              header={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.header}
              ws={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.ws}
              api={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.api}
              downloadApi={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.downloadApi}
              lastUpdatedField={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.lastUpdatedField}
              totalField={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.totalField}
              columns={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.columns}
              summaryGroupTitleColumn={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={IDQS_NMS_UNENTITLED_SYMBOLS_CONFIG.summaryGroupDataColumn}
              pauseWs={false}
              maxRows={10} />
          </div>
        </div>}
        <div key={'unmatchedTrades'} className={styles.unmatchedTrades}>
          {isMobile() && <div id='trfRiskDiv'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >TRF Trade Alerts</Outline>
            <RiskDataGrid
              identifier={TRF_TRADES_CONFIG.identifier}
              header={TRF_TRADES_CONFIG.header}
              ws={TRF_TRADES_CONFIG.ws}
              api={TRF_TRADES_CONFIG.api}
              downloadApi={TRF_TRADES_CONFIG.downloadApi}
              lastUpdatedField={TRF_TRADES_CONFIG.lastUpdatedField}
              totalField={TRF_TRADES_CONFIG.totalField}
              columns={TRF_TRADES_CONFIG.columns}
              summaryGroupTitleColumn={TRF_TRADES_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={TRF_TRADES_CONFIG.summaryGroupDataColumn}
              onUserAckRisks={this.trfAlertUserAck}
              maxRows={10} />
          </div>}
          <div id='orfTrades'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >ORF - Unmatched Trades</Outline>
            <RiskDataGrid
              identifier={UNMATCHED_TRADES_CONFIG.identifier}
              header={UNMATCHED_TRADES_CONFIG.header}
              ws={UNMATCHED_TRADES_CONFIG.ws}
              api={UNMATCHED_TRADES_CONFIG.api}
              downloadApi={UNMATCHED_TRADES_CONFIG.downloadApi}
              lastUpdatedField={UNMATCHED_TRADES_CONFIG.lastUpdatedField}
              totalField={UNMATCHED_TRADES_CONFIG.totalField}
              columns={UNMATCHED_TRADES_CONFIG.columns}
              summaryGroupTitleColumn={UNMATCHED_TRADES_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={UNMATCHED_TRADES_CONFIG.summaryGroupDataColumn}
              onUserAckRisks={this.orfRiskUserAck}
              maxRows={10} />
          </div>

          <div id='orfOtherTrades'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >ORF - Other Alerts</Outline>
            <RiskDataGrid
              identifier={UNMATCHED_OTHER_TRADES_CONFIG.identifier}
              header={UNMATCHED_OTHER_TRADES_CONFIG.header}
              ws={UNMATCHED_OTHER_TRADES_CONFIG.ws}
              api={UNMATCHED_OTHER_TRADES_CONFIG.api}
              downloadApi={UNMATCHED_OTHER_TRADES_CONFIG.downloadApi}
              lastUpdatedField={UNMATCHED_OTHER_TRADES_CONFIG.lastUpdatedField}
              totalField={UNMATCHED_OTHER_TRADES_CONFIG.totalField}
              columns={UNMATCHED_OTHER_TRADES_CONFIG.columns}
              summaryGroupTitleColumn={UNMATCHED_OTHER_TRADES_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={UNMATCHED_OTHER_TRADES_CONFIG.summaryGroupDataColumn}
              maxRows={10} />
          </div>
          <div id='lockCrossRiskDiv'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >Lock Cross Alerts</Outline>
            <RiskDataGrid
              identifier={LOCK_CROSS_QUOTES_CONFIG.identifier}
              header={LOCK_CROSS_QUOTES_CONFIG.header}
              ws={LOCK_CROSS_QUOTES_CONFIG.ws}
              api={LOCK_CROSS_QUOTES_CONFIG.api}
              downloadApi={LOCK_CROSS_QUOTES_CONFIG.downloadApi}
              lastUpdatedField={LOCK_CROSS_QUOTES_CONFIG.lastUpdatedField}
              totalField={LOCK_CROSS_QUOTES_CONFIG.totalField}
              columns={LOCK_CROSS_QUOTES_CONFIG.columns}
              summaryGroupTitleColumn={LOCK_CROSS_QUOTES_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={LOCK_CROSS_QUOTES_CONFIG.summaryGroupDataColumn}
              onUserAckRisks={this.lcAlertUserAck}
              maxRows={10} />
          </div>
          {!isMobile() && <div id='trfRiskDiv'>
            <Outline
              mode='headingSmall'
              bottomBorderOnly={false}
              topBorderOnly={false}
              className={styles.contentHeader}
            >TRF Trade Alerts</Outline>
            <RiskDataGrid
              identifier={TRF_TRADES_CONFIG.identifier}
              header={TRF_TRADES_CONFIG.header}
              ws={TRF_TRADES_CONFIG.ws}
              api={TRF_TRADES_CONFIG.api}
              downloadApi={TRF_TRADES_CONFIG.downloadApi}
              lastUpdatedField={TRF_TRADES_CONFIG.lastUpdatedField}
              totalField={TRF_TRADES_CONFIG.totalField}
              columns={TRF_TRADES_CONFIG.columns}
              summaryGroupTitleColumn={TRF_TRADES_CONFIG.summaryGroupTitleColumn}
              summaryGroupDataColumn={TRF_TRADES_CONFIG.summaryGroupDataColumn}
              onUserAckRisks={this.trfAlertUserAck}
              maxRows={10} />
          </div>}
        </div>
        <div key={'l1risks'} className={styles.l1RiskContainer}>
          <L1TradeRiskFilter search={this.setL1QueryParameters} />
          <div className={styles.l1grids}>
            <div id='l1iskDiv'>
              <Outline
                mode='headingSmall'
                bottomBorderOnly={false}
                topBorderOnly={false}
                className={styles.contentHeader}
              >L1 Trade Alerts</Outline>
              <L1RiskDataGrid
                identifier={L1_TRADES_CONFIG.identifier}
                header={L1_TRADES_CONFIG.header}
                ws={L1_TRADES_CONFIG.ws}
                api={L1_TRADES_CONFIG.api}
                downloadApi={L1_TRADES_CONFIG.downloadApi}
                filter={this.state.l1QueryParam}
                lastUpdatedField={L1_TRADES_CONFIG.lastUpdatedField}
                totalField={L1_TRADES_CONFIG.totalField}
                columns={L1_TRADES_CONFIG.columns}
                summaryGroupTitleColumn={L1_TRADES_CONFIG.summaryGroupTitleColumn}
                summaryGroupDataColumn={L1_TRADES_CONFIG.summaryGroupDataColumn}
                onUserAckRisks={this.l1AlertUserAck}
                maxRows={10} />
            </div>
          </div>
        </div>
        <div key={'risks'} className={styles.riskContainer}>
          <RiskDashboardFilter search={this.setQueryParameters} />
          <div className={styles.grids}>
            <div id='ecnRiskDiv'>
              <Outline
                mode='headingSmall'
                bottomBorderOnly={false}
                topBorderOnly={false}
                className={styles.contentHeader}
              >ECN</Outline>
              <RiskDataGrid
                identifier={ECN_RISK_CONFIG.identifier}
                header={ECN_RISK_CONFIG.header}
                ws={ECN_RISK_CONFIG.ws}
                api={ECN_RISK_CONFIG.api}
                downloadApi={ECN_RISK_CONFIG.downloadApi}
                filter={this.state.queryParam}
                lastUpdatedField={ECN_RISK_CONFIG.lastUpdatedField}
                totalField={ECN_RISK_CONFIG.totalField}
                columns={ECN_RISK_CONFIG.columns}
                summaryGroupTitleColumn={ECN_RISK_CONFIG.summaryGroupTitleColumn}
                summaryGroupDataColumn={ECN_RISK_CONFIG.summaryGroupDataColumn}
                onUserAckRisks={this.ecnRiskUserAck}
                maxRows={20} />
            </div>
            <div id='idqsRiskDiv'>
              <Outline
                mode='headingSmall'
                bottomBorderOnly={false}
                topBorderOnly={false}
                className={styles.contentHeader}
              >IDQS</Outline>
              <RiskDataGrid
                identifier={IDQS_RISK_CONFIG.identifier}
                header={IDQS_RISK_CONFIG.header}
                ws={IDQS_RISK_CONFIG.ws}
                api={IDQS_RISK_CONFIG.api}
                downloadApi={IDQS_RISK_CONFIG.downloadApi}
                filter={this.state.queryParam}
                lastUpdatedField={IDQS_RISK_CONFIG.lastUpdatedField}
                totalField={IDQS_RISK_CONFIG.totalField}
                columns={IDQS_RISK_CONFIG.columns}
                summaryGroupTitleColumn={IDQS_RISK_CONFIG.summaryGroupTitleColumn}
                summaryGroupDataColumn={IDQS_RISK_CONFIG.summaryGroupDataColumn}
                onUserAckRisks={this.idqsRiskUserAck}
                maxRows={20} />
            </div>
          </div>
        </div>
        {hasNotifications && <SystemNotifications notifications={notifications} />}

      </div>
    );
  }
}

export default withNotificationsContext(RiskDashboardPage);
